module.exports = __webpack_public_path__ + "static/HERO_RS-e5a744f409add4de01182a92fb5d16c7.png";